import UserModel from '@/models/User';

const GET_TRAVELER_EDIT_DETAIL = 'GET_TRAVELER_EDIT_DETAIL';
const GET_TRAVELER_INFO_BY_IDS = 'GET_TRAVELER_INFO_BY_IDS';
const UPDATE_TRAVELER = 'UPDATE_TRAVELER';
const DELETE_TRAVELER = 'DELETE_TRAVELER';

/**
 * 获取出行人详情
 * @param {number} id 出行人id
 */
async function getTravelerEditDetail(id) {
  const payload = await new UserModel().travelerDetail(id);
  return {
    type: GET_TRAVELER_EDIT_DETAIL,
    payload
  }
}

/**
 * 批量获取出行人信息
 * @param {Array<number>} ids 出行人id列表
 */
async function getTravelerInfoByIds(ids) {
  const payload = await new UserModel().travelerInfoByIds(ids);
  return {
    type: GET_TRAVELER_INFO_BY_IDS,
    payload
  }
}

/**
 * 新增/修改出行人信息
 * @param {Object} params {
 *    @param {number} id 如果是修改出行人需传入此参数
 * }
 */
async function updateTraveler(params) {
  await new UserModel().updateTraveler(params);
  return {
    type: UPDATE_TRAVELER,
    payload: params
  }
}

/**
 * 删除出行人
 * @param {number} id 出行人id
 */
async function deleteTraveler(id) {
  await new UserModel().deleteTraveler([id]);
  return {
    type: DELETE_TRAVELER,
    payload: id
  }
}

const ACTION_TYPES = {
  GET_TRAVELER_EDIT_DETAIL,
  GET_TRAVELER_INFO_BY_IDS,
  UPDATE_TRAVELER,
  DELETE_TRAVELER,
};

const ACTION = {
  getTravelerEditDetail,
  getTravelerInfoByIds,
  updateTraveler,
  deleteTraveler,
};

const TravelerEdit = {
  ACTION_TYPES,
  ACTION
}

export default TravelerEdit;